"use strict";Object.defineProperty(exports,"__esModule",{value:!0});exports.default=function(e){try{return"object"==typeof JSON.parse(e)}catch(e){return!1}};
